/* ==========================================================================
   Loja do Gamão — Custom Board (montador)
   Estado das escolhas, prévia ao vivo, navegação em passos e permalink.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'lg:custom-board';

  var TARGETS = {
    felt: ['--cb-felt'],
    points: ['--cb-point-a', '--cb-point-b'],
    'point-a': ['--cb-point-a'],
    'point-b': ['--cb-point-b'],
    checkers: ['--cb-checker-a', '--cb-checker-b'],
    'checker-a': ['--cb-checker-a'],
    'checker-b': ['--cb-checker-b'],
    frame: ['--cb-frame'],
    case: ['--cb-case', '--cb-frame'],
    none: []
  };

  /* Alvos que trocam a imagem da maleta em vez de só pintar uma variável. */
  var FRAME_TARGETS = { frame: true, 'case': true };

  /* ---------- utilitários ---------- */

  function limitar(v, min, max) { return Math.min(max, Math.max(min, v)); }

  /* h 0–360, s e v 0–100 */
  function hsvParaHex(h, s, v) {
    s /= 100; v /= 100;
    var f = function (n) {
      var k = (n + h / 60) % 6;
      return Math.round(255 * (v - v * s * Math.max(0, Math.min(k, 4 - k, 1))));
    };
    return '#' + [f(5), f(3), f(1)].map(function (x) {
      return ('0' + x.toString(16)).slice(-2);
    }).join('').toUpperCase();
  }

  function hexParaHsv(hex) {
    var m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex || '');
    if (!m) return { h: 0, s: 0, v: 50 };
    var r = parseInt(m[1], 16) / 255, g = parseInt(m[2], 16) / 255, b = parseInt(m[3], 16) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    var h = 0;
    if (d) {
      if (mx === r) h = ((g - b) / d) % 6;
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
      if (h < 0) h += 360;
    }
    return { h: h, s: mx ? (d / mx) * 100 : 0, v: mx * 100 };
  }

  function encodeState(state) {
    try {
      var json = JSON.stringify(state);
      var b64 = btoa(unescape(encodeURIComponent(json)));
      return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch (e) {
      return '';
    }
  }

  function decodeState(str) {
    try {
      var b64 = str.replace(/-/g, '+').replace(/_/g, '/');
      while (b64.length % 4) b64 += '=';
      return JSON.parse(decodeURIComponent(escape(atob(b64))));
    } catch (e) {
      return null;
    }
  }


  /* ---------- Fotos da maleta fechada ----------
     Sem cor escolhida: passa sozinho entre as maletas.
     Com cor escolhida: para e mostra só a foto daquela cor. */
  function carrosselMaletas(box) {
    var vazio = { mostrar: function () {} };
    if (!box) return vazio;
    var track = box.querySelector('[data-cb-cases-track]');
    var slides = Array.prototype.slice.call(box.querySelectorAll('[data-cb-case-slide]'));
    var nameEl = box.querySelector('[data-cb-cases-name]');
    var dotsEl = box.querySelector('[data-cb-cases-dots]');
    if (!track || slides.length < 2) return vazio;

    var INTERVALO = 3200;
    var calmo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var atual = 0;
    var travada = false;
    var timer = null;
    var visivel = true;
    var pausada = false;

    /* Cópia da primeira no fim, para o loop seguir sempre para a esquerda. */
    var clone = slides[0].cloneNode(true);
    clone.removeAttribute('data-cb-case-slide');
    clone.setAttribute('aria-hidden', 'true');
    clone.alt = '';
    track.appendChild(clone);

    var dots = slides.map(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cb__cases-dot';
      dot.setAttribute('aria-label', slide.dataset.cbCaseName || ('Maleta ' + (i + 1)));
      dot.addEventListener('click', function () {
        ir(i, true);
        reiniciar();
      });
      dotsEl.appendChild(dot);
      return dot;
    });

    function posicionar(i, animar) {
      track.classList.toggle('is-instant', !animar);
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      if (!animar) void track.offsetWidth;
      track.classList.remove('is-instant');
    }

    function legenda(i) {
      var real = i % slides.length;
      if (nameEl) nameEl.textContent = slides[real].dataset.cbCaseName || '';
      dots.forEach(function (dot, k) {
        dot.setAttribute('aria-current', k === real ? 'true' : 'false');
      });
    }

    function ir(i, animar) {
      atual = i;
      posicionar(i, animar && !calmo);
      legenda(i);
    }

    track.addEventListener('transitionend', function () {
      if (atual === slides.length) ir(0, false);
    });

    function avancar() {
      if (travada || pausada || !visivel || document.hidden) return;
      ir(atual + 1, true);
    }

    function parar() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function reiniciar() {
      parar();
      if (!travada && !calmo) timer = window.setInterval(avancar, INTERVALO);
    }

    box.addEventListener('mouseenter', function () { pausada = true; });
    box.addEventListener('mouseleave', function () { pausada = false; });
    box.addEventListener('focusin', function () { pausada = true; });
    box.addEventListener('focusout', function () { pausada = false; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visivel = entries[0].isIntersecting;
      }, { threshold: 0.25 }).observe(box);
    }

    /* Recebe a imagem aberta da cor escolhida ('' = nenhuma). */
    function mostrar(img) {
      var alvo = -1;
      if (img) {
        slides.forEach(function (slide, i) {
          if (alvo < 0 && slide.dataset.cbCaseKey === img) alvo = i;
        });
      }
      if (alvo >= 0) {
        travada = true;
        box.classList.add('is-locked');
        parar();
        ir(alvo, false);
      } else {
        travada = false;
        box.classList.remove('is-locked');
        reiniciar();
      }
    }

    ir(0, false);
    reiniciar();
    return { mostrar: mostrar };
  }

  function initBuilder(root) {
    if (!root || root.dataset.cbBound === '1') return;
    root.dataset.cbBound = '1';

    var form = root.querySelector('form');
    var stageWrap = root.querySelector('.cb__stage-wrap');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cb-panel]'));
    var railItems = Array.prototype.slice.call(root.querySelectorAll('[data-cb-goto]'));
    var chipsList = root.querySelector('[data-cb-chips]');
    var summaryList = root.querySelector('[data-cb-summary]');
    var progressFill = root.querySelector('[data-cb-progress-fill]');
    var progressText = root.querySelector('[data-cb-progress-text]');
    var bar = root.querySelector('[data-cb-bar]');
    var barStep = root.querySelector('[data-cb-bar-step]');
    var barBtn = root.querySelector('[data-cb-bar-next]');
    var previewCol = root.querySelector('.cb__preview-col');
    var stepsCol = root.querySelector('.cb__steps-col');
    var started = false;
    var configInput = root.querySelector('[data-cb-config]');
    var linkInput = root.querySelector('[data-cb-permalink]');
    var engraveGroups = Array.prototype.slice.call(root.querySelectorAll('[data-cb-engrave-group]'));
    var engraveTexts = Array.prototype.slice.call(root.querySelectorAll('[data-cb-engrave-text]'));
    var engraveInput = root.querySelector('[data-cb-engrave-input]');
    var frameImgs = Array.prototype.slice.call(root.querySelectorAll('[data-cb-frame-img]'));
    var cases = carrosselMaletas(root.querySelector('[data-cb-cases]'));
    frameImgs.forEach(function (node) {
      node.setAttribute('data-cb-default', node.getAttribute('href') || '');
    });

    if (!panels.length) return;

    if (form) form.setAttribute('enctype', 'multipart/form-data');

    /* O cabeçalho do tema é fixo e tem z-index maior: a prévia precisa
       estacionar abaixo dele, senão o tabuleiro aparece cortado. */
    function alturaCabecalho() {
      var topo = document.querySelector('.shopify-section--header');
      if (!topo) return 0;
      var pos = window.getComputedStyle(topo).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      return Math.round(topo.getBoundingClientRect().height);
    }

    function medirTopo() {
      root.style.setProperty('--cb-top', alturaCabecalho() + 'px');
    }

    medirTopo();
    window.addEventListener('resize', medirTopo);
    if (barBtn) barBtn.dataset.cbStartLabel = barBtn.textContent.trim();

    var lastIndex = panels.length - 1;
    var current = 0;
    var state = {};

    /* Cores que a prévia mostra antes de qualquer escolha. */
    var inicial = {};
    if (stageWrap) {
      ['--cb-felt', '--cb-point-a', '--cb-point-b', '--cb-checker-a', '--cb-checker-b',
       '--cb-engrave', '--cb-frame', '--cb-case'].forEach(function (v) {
        inicial[v] = stageWrap.style.getPropertyValue(v).trim();
      });
    }

    function restaurarAlvo(target) {
      if (FRAME_TARGETS[target]) paintFrame('');
      if (!stageWrap) return;
      (TARGETS[target] || []).forEach(function (v) {
        if (inicial[v]) stageWrap.style.setProperty(v, inicial[v]);
        else stageWrap.style.removeProperty(v);
      });
    }

    function resetarPrevia() {
      paintFrame('');
      Object.keys(inicial).forEach(function (v) {
        if (inicial[v]) stageWrap.style.setProperty(v, inicial[v]);
        else stageWrap.style.removeProperty(v);
      });
    }

    /* Volta a prévia de um passo para o que está de fato escolhido. */
    function repintarPasso(panel) {
      restaurarAlvo(panel.dataset.cbStepTarget);
      var entry = state[panel.dataset.cbStepId];
      if (entry) paint(entry.target, entry.hex1, entry.hex2, entry.img);
    }

    /* ---------- passo sem escolha ---------- */

    function pendente(panel) {
      if (!panel || !panel.hasAttribute('data-cb-required')) return false;
      var entry = state[panel.dataset.cbStepId];
      return !(entry && entry.value);
    }

    function primeiroPendente(ate) {
      for (var i = 0; i < ate && i <= lastIndex; i++) {
        if (pendente(panels[i])) return i;
      }
      return -1;
    }

    function avisar(panel, mostrarAviso) {
      var aviso = panel && panel.querySelector('[data-cb-panel-error]');
      if (!aviso) return;
      if (mostrarAviso) aviso.removeAttribute('hidden');
      else aviso.setAttribute('hidden', '');
    }

    /* Mostra a cor livre aplicada no próprio botão "Escolha a cor". */
    function marcarEscolhida(panel, hex) {
      var det = panel && panel.querySelector('.cb__custom');
      if (!det) return;
      var valor = det.querySelector('[data-cb-custom-value]');
      if (hex) {
        det.classList.add('is-chosen');
        det.style.setProperty('--cb-chosen', hex);
        if (valor) {
          valor.innerHTML = '<span class="cb__custom-kicker">Cor escolhida</span>' +
                            '<strong>' + hex.toUpperCase() + '</strong>';
        }
      } else {
        det.classList.remove('is-chosen');
        det.style.removeProperty('--cb-chosen');
        if (valor) valor.textContent = '';
      }
    }

    /* ---------- prévia ---------- */

    var PATTERN_SLOT = { 'checker-a': 'a', 'checker-b': 'b' };

    function showCheckers(slot) {
      var group = root.querySelector('[data-cb-checkers="' + slot + '"]');
      if (group) group.removeAttribute('hidden');
    }

    function hideCheckers() {
      root.querySelectorAll('[data-cb-checkers]').forEach(function (group) {
        group.setAttribute('hidden', 'hidden');
      });
    }

    var XLINK = 'http://www.w3.org/1999/xlink';

    function mostrar(nodes, visivel) {
      nodes.forEach(function (node) {
        if (visivel) node.removeAttribute('hidden');
        else node.setAttribute('hidden', 'hidden');
      });
    }

    /* Com foto da peça, a ficha vira a imagem recortada em círculo.
       Sem foto, volta para o círculo chapado com o brilho desenhado. */
    function paintChecker(slot, img) {
      var fotos = Array.prototype.slice.call(root.querySelectorAll('[data-cb-photo="' + slot + '"]'));
      var chapadas = Array.prototype.slice.call(root.querySelectorAll('[data-cb-flat="' + slot + '"]'));
      if (!fotos.length) return false;

      if (img) {
        fotos.forEach(function (node) {
          node.setAttributeNS(XLINK, 'href', img);
          node.setAttribute('href', img);
        });
        mostrar(fotos, true);
        mostrar(chapadas, false);
        return true;
      }

      mostrar(fotos, false);
      mostrar(chapadas, true);
      return false;
    }

    /* Maleta: troca o PNG da moldura pelo da cor escolhida.
       Sem imagem, volta para o arquivo original (preto). */
    function paintFrame(img) {
      cases.mostrar(img);
      if (!frameImgs.length) return false;
      frameImgs.forEach(function (node) {
        var src = img || node.getAttribute('data-cb-default') || '';
        node.setAttributeNS(XLINK, 'href', src);
        node.setAttribute('href', src);
      });
      return !!img;
    }

    function paint(target, hex1, hex2, img) {
      var vars = TARGETS[target];
      if (!vars || !vars.length || !stageWrap) return;

      var slot = PATTERN_SLOT[target];
      if (slot && paintChecker(slot, img)) return;
      if (FRAME_TARGETS[target]) paintFrame(img);

      if (hex1) stageWrap.style.setProperty(vars[0], hex1);
      if (vars[1] && hex2) stageWrap.style.setProperty(vars[1], hex2);
    }

    function paintAll() {
      Object.keys(state).forEach(function (id) {
        var entry = state[id];
        if (entry && entry.target) paint(entry.target, entry.hex1, entry.hex2, entry.img);
      });
    }

    function setEngrave(value) {
      var text = (value || '').trim();
      engraveTexts.forEach(function (node) { node.textContent = text; });
      engraveGroups.forEach(function (node) {
        if (text) node.removeAttribute('hidden');
        else node.setAttribute('hidden', '');
      });
    }

    /* ---------- chips e resumo ---------- */

    function dot(entry) {
      if (!entry.hex1 && !entry.img) return '';
      /* Na maleta a imagem é a moldura inteira: o chip mostra a cor. */
      if (entry.img && !FRAME_TARGETS[entry.target]) {
        return '<span class="cb__chip-dot" style="background-image:url(' + entry.img +
               ');background-size:cover"></span>';
      }
      var html = '<span class="cb__chip-dot"><span style="background:' + entry.hex1 + '"></span>';
      if (entry.hex2) html += '<span style="background:' + entry.hex2 + '"></span>';
      return html + '</span>';
    }

    function renderChips() {
      if (!chipsList) return;
      var html = '';
      panels.forEach(function (panel) {
        var id = panel.dataset.cbStepId;
        var entry = state[id];
        if (!entry || !entry.value) return;
        html += '<li>' + dot(entry) + '<span>' + entry.value + '</span></li>';
      });
      chipsList.innerHTML = html;
    }

    function renderSummary() {
      if (!summaryList) return;
      var html = '';
      panels.forEach(function (panel, index) {
        var id = panel.dataset.cbStepId;
        var entry = state[id];
        if (!entry) return;
        var value = entry.value || '<em>sem gravação</em>';
        html += '<li>' +
                  '<span class="cb__summary-label">' + entry.label + '</span>' +
                  '<span class="cb__summary-value">' + value + '</span>' +
                  '<button type="button" class="cb__summary-edit" data-cb-goto="' + index + '">Trocar</button>' +
                '</li>';
      });
      summaryList.innerHTML = html;
    }

    /* ---------- persistência ---------- */

    function serialize() {
      var out = {};
      Object.keys(state).forEach(function (id) {
        var entry = state[id];
        out[id] = { v: entry.value, h1: entry.hex1 || '', h2: entry.hex2 || '' };
      });
      return out;
    }

    function permalink() {
      var url = window.location.origin + window.location.pathname;
      var code = encodeState(serialize());
      return code ? url + '?c=' + code : url;
    }

    function persist() {
      var payload = {};
      panels.forEach(function (panel) {
        var id = panel.dataset.cbStepId;
        var entry = state[id];
        if (entry && entry.label) payload[entry.label] = entry.value;
      });

      if (configInput) configInput.value = JSON.stringify(payload);
      if (linkInput) linkInput.value = permalink();

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(serialize()));
      } catch (e) { /* modo privado */ }

      try {
        if (window.history && window.history.replaceState) {
          var code = encodeState(serialize());
          if (code) window.history.replaceState(null, '', '?c=' + code);
        }
      } catch (e) { /* iframe do editor */ }
    }

    /* ---------- seleção ---------- */

    function select(button, silent) {
      var panel = button.closest('[data-cb-panel]');
      if (!panel) return;

      panel.querySelectorAll('[data-cb-option]').forEach(function (other) {
        other.setAttribute('aria-checked', other === button ? 'true' : 'false');
      });

      var id = button.dataset.cbStep;
      var input = root.querySelector('[data-cb-input="' + id + '"]');
      var entry = {
        label: panel.dataset.cbStepLabel,
        target: button.dataset.cbTarget,
        value: button.dataset.cbValue,
        hex1: button.dataset.cbHex1 || '',
        hex2: button.dataset.cbHex2 || '',
        img: button.dataset.cbImg || ''
      };

      state[id] = entry;
      if (input) input.value = entry.value;
      marcarEscolhida(panel, '');
      avisar(panel, false);

      paint(entry.target, entry.hex1, entry.hex2, entry.img);
      if (!silent && PATTERN_SLOT[entry.target]) showCheckers(PATTERN_SLOT[entry.target]);
      renderChips();
      renderSummary();
      if (!silent) persist();
    }

    function selectByValue(panel, value) {
      var options = Array.prototype.slice.call(panel.querySelectorAll('[data-cb-option]'));
      var match = options.filter(function (option) {
        return option.dataset.cbValue === value;
      })[0];
      if (match) {
        select(match, true);
        return true;
      }
      return false;
    }

    function applyCustom(input) {
      var id = input.dataset.cbStep;
      var panel = input.closest('[data-cb-panel]');
      var slot = input.dataset.cbSlot === '2' ? 'hex2' : 'hex1';
      var target = input.dataset.cbTarget;

      var pair = panel.querySelectorAll('[data-cb-custom]');
      var hex1 = pair[0] ? pair[0].value : input.value;
      var hex2 = pair[1] ? pair[1].value : '';

      panel.querySelectorAll('[data-cb-option]').forEach(function (option) {
        option.setAttribute('aria-checked', 'false');
      });

      var label = panel.dataset.cbStepLabel;
      var value = 'Personalizada ' + hex1.toUpperCase();
      if (hex2 && TARGETS[target] && TARGETS[target].length > 1) {
        value += ' / ' + hex2.toUpperCase();
      }

      state[id] = { label: label, target: target, value: value, hex1: hex1, hex2: hex2, img: '' };

      var field = root.querySelector('[data-cb-input="' + id + '"]');
      if (field) field.value = value;

      marcarEscolhida(panel, hex1);
      avisar(panel, false);
      paint(target, hex1, hex2);
      renderChips();
      renderSummary();
      persist();
      void slot;
    }

    /* ---------- seletor de cor livre ---------- */

    function desenharSeletor(painel) {
      var c = painel._hsv;
      var campo = painel.querySelector('[data-cb-custom]');
      if (!c || !campo) return '';
      var hex = hsvParaHex(c.h, c.s, c.v);
      campo.value = hex;

      painel.style.setProperty('--cb-pick-hue', Math.round(c.h));
      painel.style.setProperty('--cb-pick', hex);
      painel.style.setProperty('--cb-sv-x', c.s + '%');
      painel.style.setProperty('--cb-sv-y', (100 - c.v) + '%');
      painel.style.setProperty('--cb-hue-y', (c.h / 360 * 100) + '%');

      var texto = painel.querySelector('[data-cb-pick-hex]');
      if (texto) texto.textContent = hex;

      var sv = painel.querySelector('[data-cb-sv]');
      if (sv) sv.setAttribute('aria-valuetext', hex);
      var hue = painel.querySelector('[data-cb-hue-bar]');
      if (hue) {
        hue.setAttribute('aria-valuenow', Math.round(c.h));
        hue.setAttribute('aria-valuetext', hex);
      }
      return hex;
    }

    function definirCor(painel, hex) {
      if (!painel) return;
      painel._hsv = hexParaHsv(hex);
      desenharSeletor(painel);
    }

    /* Enquanto arrasta, só pinta a prévia. A escolha só vale no "Aplicar cor". */
    function previaSeletor(painel) {
      var campo = painel.querySelector('[data-cb-custom]');
      if (campo) paint(campo.dataset.cbTarget, campo.value, '');
    }

    function prepararSeletores() {
      root.querySelectorAll('[data-cb-pick]').forEach(function (painel) {
        var campo = painel.querySelector('[data-cb-custom]');
        if (!campo) return;
        /* Input hidden não guarda valor padrão separado: a cor inicial fica aqui. */
        painel.dataset.cbDefault = campo.value;
        definirCor(painel, campo.value);
      });
    }

    function corPadrao(painel) {
      return painel.dataset.cbDefault || '';
    }

    function moverSeletor(alvo, painel, event) {
      var r = alvo.getBoundingClientRect();
      var x = limitar((event.clientX - r.left) / r.width, 0, 1);
      var y = limitar((event.clientY - r.top) / r.height, 0, 1);
      var c = painel._hsv;
      if (alvo.hasAttribute('data-cb-sv')) {
        c.s = x * 100;
        c.v = (1 - y) * 100;
      } else {
        c.h = y * 360;
      }
      desenharSeletor(painel);
      previaSeletor(painel);
    }

    root.addEventListener('pointerdown', function (event) {
      var alvo = event.target.closest('[data-cb-sv], [data-cb-hue-bar]');
      if (!alvo || !root.contains(alvo)) return;
      var painel = alvo.closest('[data-cb-pick]');
      if (!painel || !painel._hsv) return;

      event.preventDefault();
      try { alvo.setPointerCapture(event.pointerId); } catch (e) { /* noop */ }
      try { alvo.focus({ preventScroll: true }); } catch (e) { alvo.focus(); }
      moverSeletor(alvo, painel, event);

      function mover(ev) { moverSeletor(alvo, painel, ev); }
      function soltar() {
        alvo.removeEventListener('pointermove', mover);
        alvo.removeEventListener('pointerup', soltar);
        alvo.removeEventListener('pointercancel', soltar);
      }
      alvo.addEventListener('pointermove', mover);
      alvo.addEventListener('pointerup', soltar);
      alvo.addEventListener('pointercancel', soltar);
    });

    root.addEventListener('keydown', function (event) {
      var alvo = event.target.closest && event.target.closest('[data-cb-sv], [data-cb-hue-bar]');
      if (!alvo) return;
      var painel = alvo.closest('[data-cb-pick]');
      if (!painel || !painel._hsv) return;

      var passo = event.shiftKey ? 10 : 2;
      var c = painel._hsv;
      var tecla = event.key;

      if (alvo.hasAttribute('data-cb-sv')) {
        if (tecla === 'ArrowLeft') c.s = limitar(c.s - passo, 0, 100);
        else if (tecla === 'ArrowRight') c.s = limitar(c.s + passo, 0, 100);
        else if (tecla === 'ArrowUp') c.v = limitar(c.v + passo, 0, 100);
        else if (tecla === 'ArrowDown') c.v = limitar(c.v - passo, 0, 100);
        else return;
      } else {
        if (tecla === 'ArrowUp') c.h = limitar(c.h - passo * 2, 0, 360);
        else if (tecla === 'ArrowDown') c.h = limitar(c.h + passo * 2, 0, 360);
        else return;
      }

      event.preventDefault();
      desenharSeletor(painel);
      previaSeletor(painel);
    });

    /* ---------- navegação ---------- */

    /* Leva o passo atual para a tela: barra de progresso, pergunta e opções.
       No celular o topo encosta logo abaixo da prévia fixa e as opções
       terminam acima da barra do botão. Se não couber tudo, sobe até as
       opções aparecerem, mas sem esconder a pergunta do passo.
       Usa scrollBy (como a cor livre) em vez de scrollIntoView com
       scroll-margin, que alguns navegadores de celular ignoram. */
    function focusSteps() {
      if (!stepsCol) return;
      requestAnimationFrame(function () {
        medirTopo();
        var panel = panels[current];
        var cabeca = panel ? panel.querySelector('.cb__panel-head') : null;
        var fimEl = panel
          ? (panel.querySelector('[data-cb-panel-error]:not([hidden])') ||
             panel.querySelector('.cb__options') ||
             cabeca || panel)
          : stepsCol;

        var sc = rolador(stepsCol);
        var caixa = sc ? sc.getBoundingClientRect() : null;
        var base = caixa ? caixa.top : 0;
        var altura = caixa ? caixa.height : window.innerHeight;

        var topo = 10;
        if (!sc) topo += alturaCabecalho();
        if (previewCol && previaEmCima()) topo += previewCol.getBoundingClientRect().height;

        var barra = 12;
        if (bar && !bar.hasAttribute('hidden') && window.getComputedStyle(bar).display !== 'none') {
          barra += bar.getBoundingClientRect().height;
        }
        var limite = altura - barra;

        var inicio = stepsCol.getBoundingClientRect().top - base;
        var fim = fimEl.getBoundingClientRect().bottom - base;
        var delta = inicio - topo;

        if (fim - delta > limite) {
          var teto = cabeca ? cabeca.getBoundingClientRect().top - base - topo : delta;
          delta = Math.max(delta, Math.min(fim - limite, teto));
        }
        if (Math.abs(delta) < 2) return;

        if (sc) sc.scrollBy({ top: delta, behavior: 'smooth' });
        else window.scrollBy({ top: delta, behavior: 'smooth' });
      });
    }

    /* Acha o elemento que realmente rola: a janela, ou um container com
       rolagem própria (é o caso da moldura de celular da demonstração). */
    function rolador(el) {
      var n = el.parentElement;
      while (n && n !== document.body) {
        var ov = window.getComputedStyle(n).overflowY;
        if ((ov === 'auto' || ov === 'scroll') && n.scrollHeight > n.clientHeight + 4) return n;
        n = n.parentElement;
      }
      return null;
    }

    /* Ao abrir a cor livre, traz o painel inteiro para a área visível,
       sem deixar nada embaixo da prévia fixa nem atrás da barra do botão. */
    /* No celular a prévia fica fixa em cima dos passos. */
    function previaEmCima() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    /* Rola para mostrar do elemento `de` até o elemento `ate`.
       No celular o topo encosta logo abaixo da prévia fixa, mas o fim
       (botões Cancelar / Aplicar cor, aviso de passo pendente) tem prioridade:
       nunca fica atrás da barra de baixo. */
    function rolarEntre(de, ate) {
      requestAnimationFrame(function () {
        var sc = rolador(de);
        var caixa = sc ? sc.getBoundingClientRect() : null;
        var base = caixa ? caixa.top : 0;
        var altura = caixa ? caixa.height : window.innerHeight;
        var emCima = previaEmCima();

        var topo = 10;
        if (!sc) topo += alturaCabecalho();
        if (previewCol && emCima) topo += previewCol.getBoundingClientRect().height;

        var barra = 12;
        if (bar && !bar.hasAttribute('hidden') && window.getComputedStyle(bar).display !== 'none') {
          barra += bar.getBoundingClientRect().height;
        }

        var inicio = de.getBoundingClientRect().top - base;
        var fim = ate.getBoundingClientRect().bottom - base;
        var limite = altura - barra;
        var delta = 0;

        if (emCima) {
          delta = inicio - topo;
          if (fim - delta > limite) delta = fim - limite;
        } else {
          if (fim > limite) delta = fim - limite;
          if (inicio - delta < topo) delta = inicio - topo;
        }
        if (Math.abs(delta) < 2) return;

        if (sc) sc.scrollBy({ top: delta, behavior: 'smooth' });
        else window.scrollBy({ top: delta, behavior: 'smooth' });
      });
    }

    /* Seletor aberto: mostra "Passo N · Nome", a pergunta, o seletor e os botões. */
    function revelarPainel(det) {
      var panel = det.closest('[data-cb-panel]');
      var cabeca = panel ? panel.querySelector('.cb__panel-head') : null;
      var aviso = panel ? panel.querySelector('[data-cb-panel-error]:not([hidden])') : null;
      var corpo = det.querySelector('.cb__custom-body') || det;
      rolarEntre(cabeca || det, aviso || corpo);
    }

    /* Cor aplicada: mostra a pergunta e a cor escolhida. */
    function revelarEscolha(det) {
      var panel = det.closest('[data-cb-panel]');
      var cabeca = panel ? panel.querySelector('.cb__panel-head') : null;
      rolarEntre(cabeca || det, det);
    }

    /* Passo só com cor livre: abre o seletor direto em vez de mostrar o botão. */
    function abrirSolo(panel) {
      var det = panel && panel.querySelector('.cb__custom--solo');
      if (!det) return false;
      if (det.open) revelarPainel(det);
      else det.open = true;
      return true;
    }

    root.addEventListener('toggle', function (event) {
      var det = event.target;
      if (!det || !det.classList || !det.classList.contains('cb__custom')) return;
      var panel = det.closest('[data-cb-panel]');
      var painel = det.querySelector('[data-cb-pick]');
      if (!panel) return;

      if (det.open) {
        var entry = state[panel.dataset.cbStepId];
        definirCor(painel, entry && entry.hex1 ? entry.hex1 : corPadrao(painel));
        revelarPainel(det);
      } else {
        repintarPasso(panel);
      }
    }, true);

    function startFlow() {
      started = true;
      root.classList.add('is-started');
      if (barBtn && barBtn.dataset.cbNextLabel) {
        barBtn.textContent = barBtn.dataset.cbNextLabel;
      }
      if (!abrirSolo(panels[current])) focusSteps();
    }

    function goTo(index) {
      if (index < 0) index = 0;
      if (index > lastIndex) index = lastIndex;

      var falta = primeiroPendente(index);
      if (falta !== -1) {
        index = falta;
        avisar(panels[falta], true);
      }

      current = index;

      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
          return;
        }
        panel.setAttribute('hidden', '');
        /* Seletor aberto em passo escondido: fecha e descarta a cor não aplicada. */
        var aberto = panel.querySelector('.cb__custom[open]');
        if (aberto) aberto.open = false;
      });

      railItems.forEach(function (item) {
        var target = parseInt(item.dataset.cbGoto, 10);
        item.classList.toggle('is-current', target === index);
        item.classList.toggle('is-done', target < index);
      });

      var pct = Math.round(((index + 1) / panels.length) * 100);
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressText) progressText.textContent = 'Passo ' + (index + 1) + ' de ' + panels.length;
      if (barStep) barStep.textContent = 'Passo ' + (index + 1) + ' de ' + panels.length;

      if (bar) {
        if (index === lastIndex) bar.setAttribute('hidden', '');
        else bar.removeAttribute('hidden');
      }

      panels.forEach(function (panel, i) {
        var slot = PATTERN_SLOT[panel.dataset.cbStepTarget];
        if (slot && i < index) showCheckers(slot);
      });

      if (started && !abrirSolo(panels[index])) focusSteps();
    }

    /* ---------- eventos ---------- */

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-cb-option]');
      if (option && root.contains(option)) {
        select(option);
        return;
      }

      var goto = event.target.closest('[data-cb-goto]');
      if (goto && root.contains(goto)) {
        goTo(parseInt(goto.dataset.cbGoto, 10));
        return;
      }

      if (event.target.closest('[data-cb-bar-next]')) {
        if (started) goTo(current + 1);
        else startFlow();
        return;
      }

      if (event.target.closest('[data-cb-next]')) {
        goTo(current + 1);
        return;
      }

      if (event.target.closest('[data-cb-prev]')) {
        goTo(current - 1);
        return;
      }

      var done = event.target.closest('[data-cb-custom-done]');
      if (done) {
        var seletor = done.closest('[data-cb-pick]');
        var campo = seletor && seletor.querySelector('[data-cb-custom]');
        if (campo) applyCustom(campo);
        var detalhes = done.closest('details');
        if (detalhes) {
          detalhes.open = false;
          revelarEscolha(detalhes);
        }
        return;
      }

      var cancel = event.target.closest('[data-cb-custom-cancel]');
      if (cancel) {
        var aberto = cancel.closest('details');
        if (aberto) aberto.open = false;
        return;
      }

      if (event.target.closest('[data-cb-restart]')) {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
        try {
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', window.location.pathname);
          }
        } catch (e) { /* iframe do editor */ }
        state = {};
        started = false;
        hideCheckers();
        resetarPrevia();
        root.querySelectorAll('.cb__custom').forEach(function (det) { det.open = false; });
        root.querySelectorAll('[data-cb-pick]').forEach(function (painel) {
          definirCor(painel, corPadrao(painel));
        });
        panels.forEach(function (panel) {
          marcarEscolhida(panel, '');
          avisar(panel, false);
        });
        root.classList.remove('is-started');
        if (barBtn && barBtn.dataset.cbStartLabel) {
          barBtn.textContent = barBtn.dataset.cbStartLabel;
        }
        preselect();
        if (engraveInput) engraveInput.value = '';
        setEngrave('');
        persist();
        goTo(0);
      }
    });

    root.addEventListener('input', function (event) {
      var engrave = event.target.closest('[data-cb-engrave-input]');
      if (engrave) {
        var id = engrave.dataset.cbStep;
        var panel = engrave.closest('[data-cb-panel]');
        setEngrave(engrave.value);
        state[id] = {
          label: panel.dataset.cbStepLabel,
          target: 'none',
          value: engrave.value.trim(),
          hex1: '',
          hex2: '',
          img: ''
        };
        renderChips();
        renderSummary();
        persist();
      }
    });

    if (form) {
      /* Captura: roda antes do envio por AJAX do tema. */
      form.addEventListener('submit', function (event) {
        var falta = primeiroPendente(panels.length);
        if (falta === -1) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        goTo(falta);
      }, true);

      form.addEventListener('submit', function () {
        persist();
        // Propriedades em branco não vão para o pedido.
        form.querySelectorAll('input[name^="properties"]').forEach(function (field) {
          if (field.type === 'file') {
            field.disabled = !(field.files && field.files.length);
          } else {
            field.disabled = !field.value;
          }
        });
        window.setTimeout(function () {
          form.querySelectorAll('input[name^="properties"]').forEach(function (field) {
            field.disabled = false;
          });
        }, 1200);
      });
    }

    /* ---------- estado inicial ---------- */

    function preselect() {
      panels.forEach(function (panel) {
        if (panel.hasAttribute('data-cb-no-preselect')) return;
        var first = panel.querySelector('[data-cb-option]');
        if (first) select(first, true);
      });
    }

    function restore() {
      var saved = null;
      try {
        saved = new URLSearchParams(window.location.search).get('c');
      } catch (e) { saved = null; }
      var data = saved ? decodeState(saved) : null;

      if (!data) {
        try {
          var stored = localStorage.getItem(STORAGE_KEY);
          if (stored) data = JSON.parse(stored);
        } catch (e) { data = null; }
      }

      if (!data) return false;

      var applied = false;
      panels.forEach(function (panel) {
        var id = panel.dataset.cbStepId;
        var entry = data[id];
        if (!entry || !entry.v) return;

        if (selectByValue(panel, entry.v)) {
          applied = true;
          return;
        }

        var field = root.querySelector('[data-cb-input="' + id + '"]');
        var engrave = panel.querySelector('[data-cb-engrave-input]');

        if (engrave) {
          engrave.value = entry.v;
          setEngrave(entry.v);
        }

        state[id] = {
          label: panel.dataset.cbStepLabel,
          target: panel.dataset.cbStepTarget || 'none',
          value: entry.v,
          hex1: entry.h1 || '',
          hex2: entry.h2 || '',
          img: ''
        };
        if (field) field.value = entry.v;
        if (entry.h1 && !engrave) {
          marcarEscolhida(panel, entry.h1);
          definirCor(panel.querySelector('[data-cb-pick]'), entry.h1);
        }
        applied = true;
      });

      if (applied) {
        paintAll();
        renderChips();
        renderSummary();
      }
      return applied;
    }

    /* Deixa as molduras das outras cores em cache, para a troca não piscar. */
    window.setTimeout(function () {
      root.querySelectorAll('[data-cb-option][data-cb-img]').forEach(function (option) {
        if (!FRAME_TARGETS[option.dataset.cbTarget]) return;
        var pre = new Image();
        pre.src = option.dataset.cbImg;
      });
    }, 1200);

    prepararSeletores();
    preselect();
    restore();
    persist();
    goTo(0);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cb-root]').forEach(initBuilder);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();